import { effect, inject, Injectable } from '@angular/core';
import { AuthService } from '@common/services';
import { DomainEffectService } from '@common/services/domain/domain-effect.service';
import { DomainStateService } from '@common/services/domain/domain-state.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DomainBootstrapService {
  private readonly authService = inject(AuthService);
  private readonly domainEffect = inject(DomainEffectService);
  private readonly domainState = inject(DomainStateService);

  #prevDomainId: string | undefined;

  protected readonly domainIdEffect = effect(() => {
    const domainId = this.domainState.domain()?.Id;

    if (this.#prevDomainId && !domainId) {
      this.authService.logout();
    }

    this.#prevDomainId = domainId;
  });

  resolveAuthGuard(): Observable<boolean> {
    return this.domainEffect.fetchDomain(true).pipe(
      map(Boolean),
      catchError(() => of(false))
    );
  }
}
